<template>
  <LayoutDashboard title="Ordens de Serviço">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarOrdemServico()"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-ordem-servico')"
          >Cadastrar</v-btn
        >
        <v-spacer></v-spacer>
        <h3>Registros: {{ getOrdensServicos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getOrdensServicos.current_page"
          :length="getOrdensServicos.last_page"
          @input="listarOrdemServico({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="8%">
                  <v-text-field
                    v-model="dataPagina.id"
                    outlined
                    dense
                    class="mt-2"
                    label="Cód."
                    @input="debouncedPesquisar()"
                    type="number"
                  ></v-text-field>
                </th>
                <th width="30%">
                  <v-text-field
                    v-model="dataPagina.cliente"
                    outlined
                    dense
                    class="mt-2"
                    label="Cliente"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-autocomplete
                    :items="['', ...getFuncionarios]"
                    v-model="dataPagina.tecnicoId"
                    label="Técnico"
                    outlined
                    dense
                    item-text="nome_abreviado"
                    item-value="id"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-autocomplete>
                </th>
                <th width="15%">
                  <v-select
                    :items="[
                      '',
                      'EM ABERTO',
                      'EM ANDAMENTO',
                      'CONCLUÍDO',
                      'CANCELADO',
                      'EXCLUÍDO'
                    ]"
                    v-model="dataPagina.status"
                    label="Status"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th width="15%">
                  <v-text-field
                    v-model="dataPagina.referencia"
                    outlined
                    dense
                    class="mt-2"
                    label="Referência"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="5%">
                  Data Início
                  <!-- <v-text-field
                  v-model="dataPagina.dataInicio"
                  outlined
                  dense
                  class="mt-2"
                  label="Data Início"
                  @input="debouncedPesquisar()"
                  type="date"
                ></v-text-field> -->
                </th>
                <th width="5%">
                  Data Fim
                  <!-- <v-text-field
                  v-model="dataPagina.dataFim"
                  outlined
                  dense
                  class="mt-2"
                  label="Data Fim"
                  @input="debouncedPesquisar()"
                  type="date"
                ></v-text-field> -->
                </th>
                <th>Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="o in getOrdensServicos.data" :key="o.id">
                <td align="center">{{ o.id }}</td>
                <td>{{ o.cliente.nome }}</td>
                <td>{{ o.tecnico ? o.tecnico.nome_abreviado : '' }}</td>
                <td :class="getCorStatus(o.status)">{{ o.status }}</td>
                <td> {{o.referencia}}</td>
                <td>
                  {{ o.data_inicio ? $helper.formatDate(o.data_inicio) : "" }}
                </td>
                <td>{{ o.data_fim ? $helper.formatDate(o.data_fim) : "" }}</td>
                <td>{{ $helper.formatReal(parseFloat(o.total)) }}</td>
                <td>
                  <TooltipButton
                    @click.native="visualizarOrdemServico(o.id)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-ordem-servico')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <h3>Registros: {{ getOrdensServicos.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getOrdensServicos.current_page"
          :length="getOrdensServicos.last_page"
          @input="listarOrdemServico({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-actions>
    </v-card>
    <ModalCadastro v-if="getModalCadastroOrdemServico" />
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastro from "@/pages/ordemServico/ModalCadastro";
var _ = require("lodash");
export default {
  components: {
    ModalCadastro,
  },
  data() {
    return {
      dataPagina: {
        id: "",
        cliente: "",
        dataInicio: "",
        dataFim: "",
        funcionarioId: "",
        status: "",
        dataInicio: "",
        referencia: "",
        data: "",
        limit: 20,
        page: 1,
        
      },
    };
  },
  computed: {
    ...mapGetters(["getOrdensServicos", "getFuncionarios"]),
  },
  methods: {
    ...mapActions([
      "cadastrarOrdemServico",
      "listarOrdemServico",
      // "listarFuncionarios",
      "visualizarOrdemServico",
      "getModalCadastroOrdemServico",
    ]),
    pesquisar() {
      this.listarOrdemServico(this.dataPagina);
    },
    getCorStatus(status) {
      if (status == "EM ABERTO") {
        return "emAberto";
      } else if (status == "EM ANDAMENTO") {
        return "emAndamento";
      } else if (status == "CONCLUÍDO") {
        return "concluido";
      } else {
        return "cancelado";
      }
    },
  },
  created() {
    this.listarOrdemServico(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
    // this.listarFuncionarios();
  },
};
</script>
<style scoped>
.emAberto {
  background-color: #f3e694;
}
.emAndamento {
  background-color: #a8faba;
}
.concluido {
  background-color: #a9fffb;
}
.cancelado {
  background-color: #ffa393;
}
</style>